import { IDS } from '../master-doc-list-action-id.constants';
import {TYPES} from "../master-doc-list-action-type.constants";
import { TAB_SELECT, TAB_SHOW } from '../../../../common/tabs/tabs.constants'
import * as Actions from '../master-doc-list.actions';
import {GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from "lodash/get";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import { saveAs } from 'file-saver';
/**
 * Creates a new RcoMasterDocListExportController.
 * @class
 */
class RcoMasterDocListExportController {
  constructor(
    $ngRedux,
    $state,
    $stateParams,
    $scope,
    $rootScope,
    $filter,
    AuthService,
    Notifier,
    DocumentService,
  ) {
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    this.AuthService = AuthService;
    this.Notifier = Notifier;
    this.DocumentService = DocumentService;
  }

  $onInit() {
    this.identifier = IDS.masterDocList;
    this.tabState = IDS.app_accreditation_scheme_master_doc_list_export;
    this.tabsState = this.$state.$current.parent.name; //IDS.app_accreditation_scheme_master_doc_list;

    this.unsubscribe = this.$ngRedux.connect(
      (state) => {
        const masterDocList = state.accreditation.masterDocList;
        return {
          schemeName: masterDocList.frameworkDetails.title || "Documents",
          assessmentStatus: masterDocList.masterDocListExport.assessmentStatus,
          siteLocationUuid: masterDocList.masterDocListExport.slo_uuid,
          siteLocationName: masterDocList.masterDocListExport.slo_name,
        };
      },
      {
        ...Actions,
      },
    )(this);

    this.schemeCode = this.$stateParams.itemCode;
  }
  onBtnExport() {
    if (this.assessmentStatus === "app" && !!this.siteLocationUuid ) {
      this.Notifier.info("Download archive is in progress!", true);
      const filter = {
        framework_code: this.schemeCode,
        loc_uuid: this.siteLocationUuid,
      };
      // trigger api call to
      // 1. call db sp to get documents list for summary document
      // 2. export summary document to pdf file
      this.DocumentService.fetchDocumentToken("rco", filter, null).then(
        (response) => {
          this.$scope.disabled = true;
          this.DocumentService.downloadZip(response.data.token).then(
            (response) => {
              saveAs(
                new Blob([response.data], { type: "octet/stream" }),
                `${this.schemeName}-${this.siteLocationName}-Documents` +
                  Date.now() +
                  ".zip",
              );
              this.Notifier.success("Download archive completed!");
              this.$scope.disabled = false;
            },
            (error) => {
              this.Notifier.error("Error downloading archive!");
              this.$scope.disabled = false;
            },
          );
        },
        (error) => {
          this.$scope.cursorState = "default";
          this.Notifier.error(
            "Error fetching documents list! Archive is too big!",
          );
          this.$scope.disabled = false;
        },
      );
    }

    // const params = {
    //     slo: this.$ngRedux.getState().accreditation.masterDocList.masterDocListExport.slo,
    //     assessment_status: this.$ngRedux.getState().accreditation.masterDocList.masterDocListExport.assessment_status,
    // };
    // this.exportRcoMasterDocList(this.schemeCode, this.requirement_id, params)
    //     .then( response => {
    //         const contentDisposition = get(response, 'headers["content-disposition"]', '');
    //         let filename = 'master_document_list.xlsx';
    //         const filenameMatch = contentDisposition.match(/filename="(.+)"/);
    //         if (filenameMatch.length === 2) {
    //             filename = filenameMatch[1];
    //         }
    //         this.downloadFileFromResponse(response, filename);
    //     })
    //     .catch( error => {
    //         this.error(this.$filter('translate')('ACCREDITATION.MASTER_DOC_LIST.EXPORT.ERROR_MESSAGE'));
    //     });
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

RcoMasterDocListExportController.$inject = [
    "$ngRedux",
    "$state",
    "$stateParams",
    "$scope",
    "$rootScope",
    "$filter",
    "AuthService",
    "Notifier",
    "DocumentService",
];

export const masterDocListExport = {
  controller: RcoMasterDocListExportController,
  template: `
    <tabs-header title="{{'ACCREDITATION.MASTER_DOC_LIST.EXPORT.TAB' | translate}}"></tabs-header>

    <form id="masterDocListAddForm" name="$ctrl.masterDocListAddForm" novalidate style="margin-left: 20px">
        <div layout-gt-xs="row"  flex>
            <select-cascade
                            identifier="{{$ctrl.identifier}}"
                            state-path="masterDocListExport"
                            purpose="'aeq'"
                            validate="true"
                            max="slo">
            </select-cascade>
        </div>
        <div layout-gt-xs="row">
            <input-select flex-gt-md="20"
                          label="{{'ACCREDITATION.MASTER_DOC_LIST.EXPORT.ASSESSMENT_STATUS' | translate}}"
                          identifier="{{$ctrl.identifier}}"
                          name="type_code"
                          state-path="masterDocListExport.assessmentStatus"
                          state-data="exportAssessmentStates"
                          state-data-identifier="{{$ctrl.identifier}}"
                          select-first-item="true"
                          required="true">
            </input-select>
        </div>
        <tabs-navigation identifier="{{$ctrl.tabsState}}"
                         state="{{$ctrl.tabState}}"
                         on-exec="$ctrl.onBtnExport()">
        </tabs-navigation>
    </form>`,
};
